/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import profileImg from '../../imagen/user.jpg';

function NavAvatar() {
  const btn_Salir = async (event) => {
    event.preventDefault();
    await delay(500);
    localStorage.clear();
    window.location.reload();
  };

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const [nombre, setNombre] = useState("");
  useEffect(() => {
    const user = localStorage.getItem("nb_UsuarioCompleto");
    setNombre(user);
  }, []);

 const nombreCompleto = localStorage.getItem("nb_UsuarioCompleto")?.split('.-')[1] || '';
 

  return (
    <li className="nav-item dropdown pe-3">
      <a
        className="nav-link nav-profile d-flex align-items-center pe-0"
        href="#"
        data-bs-toggle="dropdown"
      >
        {/*<img src={imageSrc} alt="Profile" className="rounded-circle" />*/}
        <span className="d-none d-md-block dropdown-toggle ps-2">{nombreCompleto}</span>
      </a>

      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
        <li className="dropdown-header">
          <h6>{nombreCompleto}</h6>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>


       
        <li>
          <a className="dropdown-item d-flex align-items-center" href="#">
            <i className="bi bi-box-arrow-right"></i>
            <span onClick={btn_Salir}>SALIR</span>
          </a>
        </li>
      </ul>
    </li>
  );
}

export default NavAvatar;
